import React, {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import Alert from "@mui/material/Alert";

// Temporary rollout feature (PFS-10283) — safe to delete this file and its usage in
// TakeoffsRouter.tsx once the beta opt-in rollout is complete.
// Bump this suffix whenever the banner's copy changes, so users who dismissed an earlier
// version see the new one instead of it staying hidden forever.
const BANNER_VERSION = 2;
const BANNER_DISMISSED_KEY = `takeoffs.v1BetaOptInBannerDismissed.v${BANNER_VERSION}`;

// Help-guide article covering the new (V2) interface — linked from the banner (PFS-10413).
const HELP_GUIDE_URL =
	"https://helpguide.simprogroup.com/articles/#!help-guide/new-view-how-to-create-simpro-takeoffs";

const BetaOptInBanner: React.FC = () => {
	const {t} = useTranslation();
	const [isDismissed, setIsDismissed] = useState(
		() => localStorage.getItem(BANNER_DISMISSED_KEY) === "true"
	);

	const dismiss = useCallback(() => {
		localStorage.setItem(BANNER_DISMISSED_KEY, "true");
		setIsDismissed(true);
	}, []);

	if (isDismissed) {
		return null;
	}

	return (
		<Alert severity="info" onClose={dismiss}>
			{t("betaOptIn.banner.message")}{" "}
			(
			<a href={HELP_GUIDE_URL} target="_blank" rel="noopener noreferrer">
				{t("betaOptIn.banner.helpLinkText")}
			</a>
			) {t("betaOptIn.banner.helpLinkSuffix")}
		</Alert>
	);
};

export default BetaOptInBanner;
